import React from "react";

import styles from "./CustomTextAreaField.module.css"

interface FieldProps {
    disabled?: boolean
    isRequired: boolean
    title: string
    value?: any
    setValue: (value: any) => void
    maxLength: number
    placeholder?: string
    errorMessage?: string
}


export const CustomTextAreaField: React.FC<FieldProps> = ({
                                                              disabled,
                                                              isRequired,
                                                              title,
                                                              value,
                                                              setValue,
                                                              maxLength,
                                                              placeholder,
                                                              errorMessage
                                                          }) => {
    return <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
            <span className={styles.title}>{title}</span>
            {isRequired && <span className={styles.asterisk}>*</span>}
        </div>
        <textarea
            maxLength={maxLength}
            value={value ?? ""}
            disabled={disabled}
            placeholder={placeholder}
            onChange={e => setValue(e.target.value)}
            className={errorMessage ? styles.textAreaWithError : styles.textArea}
        />
        <div style={{visibility: `${!errorMessage ? "hidden" : "visible"}`}} className={styles.errorWrapper}>
            <img src={"/alertIcon.svg"} alt={"alert icon"}/>
            <span className={styles.errorMessage}>{errorMessage}</span>
        </div>
        <span className={errorMessage ? styles.errorNumber : styles.number}>{value?.length | 0}/{maxLength}</span>
    </div>
}
